import React, { lazy } from 'react';
import Loadable from '../../components/Loadable';
import config from './config';
const ChangePlatform = Loadable(lazy(() => import('./AbmComponents/changePlatform')));

const routes = [
  {
    path: 'cambiarPlataforma',
    element: <ChangePlatform config={config} />,
  },
];
export default routes;
